import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const BG_DIALOG      = '#1c1c24';
const BRAND_RED      = '#c0392b';
const TEXT_PRIMARY   = '#f4f4f6';
const TEXT_SECONDARY = 'rgba(244,244,246,0.65)';
const BORDER_SUBTLE  = '1px solid rgba(255,255,255,0.08)';

interface YesNoDialogModalProps {
    message: string;
    onYesClick: (projectToDeleteId: string) => void;
    onCloseClick: (confirmation: boolean) => void;
}

export const YesNoDialogModal: React.FC<YesNoDialogModalProps & { onYesClick: () => void }> = ({ message, onYesClick, onCloseClick }) => {
    return (
        <Dialog
            open={true}
            onClose={() => onCloseClick(false)}
            maxWidth='xs'
            fullWidth
            sx={{ zIndex: 1400 }}
            PaperProps={{
                sx: {
                    bgcolor: BG_DIALOG,
                    color: TEXT_PRIMARY,
                    border: BORDER_SUBTLE,
                },
            }}
        >
            <DialogContent sx={{ pt: 3, pb: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5 }}>
                <WarningAmberIcon sx={{ fontSize: 40, color: BRAND_RED }} />
                <Typography
                    variant='body2'
                    color={TEXT_SECONDARY}
                    textAlign='center'
                    dangerouslySetInnerHTML={{ __html: message }}
                />
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', gap: 1, pb: 2.5 }}>
                <Button
                    onClick={() => onCloseClick(false)}
                    sx={{ color: TEXT_SECONDARY, textTransform: 'none', minWidth: 80 }}
                >
                    No
                </Button>
                <Button
                    variant='contained'
                    onClick={() => { onYesClick(); onCloseClick(false); }}
                    sx={{ bgcolor: BRAND_RED, textTransform: 'none', fontWeight: 600, minWidth: 80, '&:hover': { bgcolor: '#a93226' } }}
                >
                    Yes
                </Button>
            </DialogActions>
        </Dialog>
    );
};
